import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { PropertyStatus } from '@letly/models';
import { PropertyDetailService } from '../../public-property-detail/data/property-detail.service';

export const letAgreedPropertyGuard: CanActivateFn = (route) => {
  const propertyDetailService = inject(PropertyDetailService);
  const router = inject(Router);
  const propertyId = route.paramMap.get('id');

  if (!propertyId) return true;

  return propertyDetailService.getPropertyDetail(propertyId).pipe(
    map((res) =>
      res.success && res.data?.status === PropertyStatus.LetAgreed
        ? router.createUrlTree(['/property', propertyId])
        : true,
    ),
  );
};
